import { URLS } from '@/data/config';
import { createActiveCashWalletHeaders } from '@/hooks/use-active-wallet';
import { useMutation } from '@tanstack/react-query';

export const useRedeemToFantasy = () => {
    return useMutation({
        mutationFn: (amount: number) => {
            const body = new URLSearchParams();
            body.append('amount', amount.toString());

            const headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
                ...createActiveCashWalletHeaders(),
            };

            return fetch(`${URLS.CHAMELON_API_URL}/auth/wallet/redeem-to-fantasy`, {
                method: 'POST',
                headers,
                body: body.toString(),
            });
        },
    });
};
